export const RELACIONES_REPRESENTANTE = [
  { value: "MADRE" as "MADRE", label: "Madre" },
  { value: "PADRE" as "PADRE", label: "Padre" },
  { value: "ABUELO" as "ABUELO", label: "Abuelo/a" },
  { value: "TUTOR" as "TUTOR", label: "Tutor" },
  { value: "OTRO" as "OTRO", label: "Ninguno de los anteriores" },
];

export const QUESTIONNAIRE_TYPE = {
  MANUAL: "MANUAL" as "MANUAL",
  DIGITAL: "DIGITAL" as "DIGITAL",
};
